import React from 'react'

import DatePicker from './datePicker'
import { useStyles } from './styles'

const DateFilters = () => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <DatePicker id={`datePickerFilter`} />
    </div>
  )
}

export default DateFilters
